import { render, staticRenderFns } from "./UploadPic.vue?vue&type=template&id=45a53f3e&scoped=true&"
import script from "./UploadPic.vue?vue&type=script&lang=js&"
export * from "./UploadPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a53f3e",
  null
  
)

export default component.exports